<div class="clients py-3 pagination-order">
  <header
    class="user-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>{{ newHeading }}</h1>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="user-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="pi pi-cloud-upload icon-blue mx-1"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Add me-2"></i>
        <a class="link" (click)="onClientRedirection()">Add New Client</a>
      </div>
    </div>
  </header>
  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="filterClientList"
    [(selection)]="selectedClients"
    styleClass="p-datatable-customers cliet-listing search-more"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [paginator]="false"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [filterDelay]="0"
    [paginator]="true"
    [rows]="20"
    (onFilter)="onFilter($event)">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 7rem">Account</th>
        <th class="notes">
          <i class="icon icon-Notes me-2"></i> /
          <i class="icon icon-Attachment me-2"></i>
        </th>
        <th
          [ngClass]="{ trimmedby40char: organizationNameCharacterCond }"
          class="jname">
          Name
        </th>
        <th pSortableColumn="availableCredit">
          Available Credit
          <p-sortIcon field="availableCredit"></p-sortIcon>
        </th>
        <th
          pSortableColumn="clientPrimaryAddress"
          [ngClass]="{ trimmedby50char: descriptionCharacterCond }">
          Address <p-sortIcon field="clientPrimaryAddress"></p-sortIcon>
        </th>
        <th>Contact</th>
        <th>BC</th>
        <th pSortableColumn="protectionNumber">
          Safe Days <p-sortIcon field="protectionNumber"></p-sortIcon>
        </th>
        <th>Billing Rep</th>
        <th>Last Order</th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="customerAccount"
              id="customerAccount"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'customerAccount',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="organizationNameD365"
              id="organizationNameD365"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'organizationNameD365',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              id="clientPrimaryAddress"
              name="clientPrimaryAddress"
              pInputText
              type="text"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'clientPrimaryAddress',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              name="brandingconsultant"
              id="brandingconsultant"
              pInputText
              type="text"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'brandingconsultant',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>
        <th></th>
        <th></th>
        <th>
          <jni-date-filter
            [dataList]="clientListings"
            [columnName]="lastOrderDateColumn"
            (emitCancelFilter)="clearFilter($event)"
            (emitApplyFilter)="applyFilter($event)"></jni-date-filter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-clientList>
      <tr class="p-selectable-row">
        <td style="width: 8rem">
          <p-checkbox
            inputId="account"
            [(ngModel)]="clientList.isActive"
            [binary]="true"
            class="me-2"
            (click)="checkboxSelection()"></p-checkbox>
          <a
            class="link"
            (click)="redirectToSummaryPage(clientList.customerAccount)"
            >{{ clientList.customerAccount }}</a
          >
        </td>

        <td class="notes">
          <i class="icon icon-Notes me-2"></i>
          <i class="icon icon-Attachment me-2"></i>
        </td>
        <td
          [ngClass]="{
            'trimmeddescription trimmedby40char': organizationNameCharacterCond,
          }"
          class="name">
          {{ organizationNameCharacterCount(clientList.organizationNameD365)
          }}{{ clientList.organizationNameD365 }}
        </td>
        <td>
          <span class="credit">{{
            clientList.availableCredit | number: ".2"
          }}</span>
          <span class="ms-2">USD</span>
          <i
            *ngIf="clientList.availableCredit === 0"
            class="icon icon-Error ms-2"></i>
        </td>
        <td
          [ngClass]="{
            'trimmeddescription trimmedby50char': descriptionCharacterCond,
          }">
          {{ clientList.clientPrimaryAddress }}
          {{ descriptionCharacterCount(clientList.clientPrimaryAddress) }}
        </td>
        <td>
          <span class="c-title">{{ clientList.primaryContactName }}</span>
          <a
            style="text-decoration: none"
            [title]="clientList.primaryContactNumber"
            [href]="'tel:' + clientList.primaryContactNumber"
            ><i
              class="icon icon-Call ms-2"
              *ngIf="clientList.primaryContactNumber">
            </i>
          </a>
          <a
            style="text-decoration: none"
            [title]="clientList.primaryContactEmail"
            [href]="'mailto:' + clientList.primaryContactEmail">
            <i
              class="icon icon-Email ms-2"
              *ngIf="clientList.primaryContactEmail">
            </i>
          </a>
        </td>
        <td>{{ clientList.brandingconsultant }}</td>
        <td>
          <span *ngIf="clientList?.protectionNumber !== -1">
            {{ clientList.protectionNumber }}
          </span>
        </td>
        <td>{{ clientList.billingRepD365 }}</td>
        <td>
          <a
            class="link"
            (click)="redirectToOrderListingPage(clientList.customerAccount)"
            >{{ clientList?.lastOrderDate | date: "yyyy-MM-dd" }}</a
          >
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No users found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="addScollHiddenClass()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
